module.exports = __webpack_public_path__ + "static/media/truck.27e56064.svg";